var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 63,
    viewBox: "0 0 64 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0937 15.2453C31.9527 14.2345 33.7937 12.336 34.1492 8.77504C29.9941 10.9116 28.035 11.0303 23.998 8.71508C20.4971 6.57851 14.1461 6.69843 16.0453 11.0303C16.5207 12.3366 17.9457 13.8197 19.7861 14.9455C6.19086 20.7036 1.32423 34.0003 2.09821 43.4967C3.34271 58.1578 41.629 59.1086 44.5371 44.2689C46.7924 32.5771 36.3451 18.0947 28.0937 15.2453ZM24.534 40.9441V43.3181H22.9897V41.0646C21.5641 41.0646 20.0828 40.5892 19.1908 40.1151L19.7861 38.6307C20.617 39.1043 21.982 39.5216 23.3458 39.5216C25.1869 39.5216 26.3133 38.6894 26.3133 37.3832C26.3133 36.1968 25.4243 35.4846 23.5232 34.7742C20.9718 33.8822 19.4294 32.9344 19.4294 30.9747C19.4294 29.193 20.8525 27.7686 23.1678 27.4719V25.2166H24.7708V27.3538C26.2564 27.4137 27.2641 27.7692 27.975 28.1247L27.3822 29.5509C26.8486 29.2542 25.8385 28.8387 24.1779 28.8387C22.2781 28.8387 21.5641 29.7877 21.5641 30.6767C21.5641 31.8643 22.4562 32.4596 24.5934 33.2306C27.2047 34.1801 28.5086 35.249 28.5086 37.2645C28.5086 38.9874 27.1454 40.5905 24.534 40.9459V40.9441Z",
    fill: "#F48000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3826 21.7349H15.293V50.5528H34.3826V21.7349Z",
    fill: "#F48000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0503 46.2348H24.5407L19.7891 39.603H20.2987L25.0503 46.2348Z",
    fill: "#FFE4C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3018 39.6034H19.7921L18.1328 37.2876H18.6425L20.3018 39.6034Z",
    fill: "#FFE4C6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6425 35.3511H18.1328V37.287H18.6425V35.3511Z",
    fill: "#FFE4C6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6425 35.3512H18.1328C22.5467 35.3512 23.8781 33.5347 23.9405 31.5376H24.4501C24.3877 33.5347 23.0563 35.3512 18.6425 35.3512Z",
    fill: "#FFE4C6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5605 29.8413H18.0508V31.538H18.5605V29.8413Z",
    fill: "#FFE4C6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3485 29.8414H23.8389C23.5501 28.4268 22.4224 27.312 18.0508 27.312H18.5605C22.9315 27.312 24.0597 28.4262 24.3485 29.8414Z",
    fill: "#FFE4C6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5605 24.9531H18.0508V27.3124H18.5605V24.9531Z",
    fill: "#FFE4C6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7952 24.953V26.6607H25.519C25.9815 27.062 26.4012 27.844 26.6766 28.8064C26.7684 29.1356 26.8473 29.4831 26.8993 29.8411H29.7945V31.5377H26.9874C26.8069 34.9133 24.466 36.2416 22.8654 36.7586C22.0192 37.0303 21.4147 37.0712 21.3829 37.0731L21.9433 37.8978L27.6292 46.2343H25.0515L20.2999 39.6018L18.6406 37.286V35.3501C23.0544 35.3501 24.3858 33.5335 24.4482 31.5365H18.5586V29.8398H24.3467C24.0579 28.4252 22.9302 27.3105 18.5586 27.3105V24.9512H29.7933L29.7952 24.953Z",
    fill: "#FFE4C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.289c8b933bee9b9d3e2a562d9bfbef10.svg";
export { ForwardRef as ReactComponent };